import clsx from 'clsx';

type Props = React.ComponentProps<'svg'> & {
  variant?: 'loading' | 'small' | 'default';
};
export function Logo({variant, className, ...props}: Props): React.JSX.Element {
  return (
    <svg
      {...props}
      viewBox={clsx(variant === 'small' ? '0 0 235 112' : '0 0 235 193')}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {variant === 'loading' && (
        <style>{`
          @keyframes moveGradient1 {
          0%, 100% {
          stop-color: #E023FF;
          offset: 0%;
          }
          50% {
          stop-color: #0ADAFF;
          offset: 100%;
          }
          }
          @keyframes moveGradient2 {
          0%, 100% {
          stop-color: #E023FF;
          offset: 100%;
          }
          50% {
          stop-color: #0ADAFF;
          offset: 0%;
          }
          }
          .stop1 {
          animation: moveGradient1 4s linear infinite;
          }
          .stop2 {
          animation: moveGradient2 4s linear infinite;
          }
        `}</style>
      )}
      <defs>
        <linearGradient
          id="lg"
          gradientUnits="userSpaceOnUse"
          x1={clsx(
            (!variant || variant === 'default') && '130',
            variant === 'small' && '215',
            variant === 'loading' && '135'
          )}
          y1={clsx(
            (!variant || variant === 'default') && '126',
            variant === 'small' && '85',
            variant === 'loading' && '107'
          )}
          x2={clsx(
            (!variant || variant === 'default') && '203',
            variant === 'small' && '233',
            variant === 'loading' && '241'
          )}
          y2={clsx(
            (!variant || variant === 'default') && '179',
            variant === 'small' && '105',
            variant === 'loading' && '192'
          )}
        >
          {variant === 'loading' ? (
            <>
              <stop className="stop1" offset="0%" stopColor="#E023FF" />
              <stop className="stop2" offset="100%" stopColor="#0ADAFF" />
            </>
          ) : (
            <stop stopColor="#E023FF" />
          )}
        </linearGradient>

        <mask id="logo-mask">
          <g
            style={{transformBox: 'fill-box', animationFillMode: 'both'}}
            className={clsx('fill-[#fff]')}
          >
            {/* a */}
            <path d="M170.613 190.047L167.477 162.972L171.005 153.079L167.477 143.316L170.613 115.981H193.221L188.909 153.079L193.221 190.047H170.613ZM176.363 153.079C174.969 160.889 172.399 167.745 168.653 173.646C164.994 179.46 160.333 183.973 154.67 187.184C149.094 190.395 142.822 192 135.852 192C128.621 192 122.218 190.395 116.642 187.184C111.066 183.886 106.71 179.33 103.574 173.516C100.525 167.615 99 160.802 99 153.079C99 145.269 100.525 138.457 103.574 132.642C106.71 126.741 111.066 122.185 116.642 118.974C122.218 115.677 128.621 114.028 135.852 114.028C142.822 114.028 149.094 115.633 154.67 118.844C160.333 122.055 165.038 126.611 168.784 132.512C172.53 138.326 175.056 145.182 176.363 153.079ZM121.085 153.079C121.085 157.418 121.956 161.236 123.699 164.534C125.528 167.832 128.011 170.435 131.148 172.344C134.284 174.167 137.899 175.078 141.994 175.078C146.089 175.078 149.922 174.167 153.494 172.344C157.153 170.435 160.377 167.832 163.164 164.534C165.952 161.236 168.13 157.418 169.699 153.079C168.13 148.74 165.952 144.922 163.164 141.624C160.377 138.24 157.153 135.636 153.494 133.814C149.922 131.905 146.089 130.95 141.994 130.95C137.899 130.95 134.284 131.905 131.148 133.814C128.011 135.636 125.528 138.24 123.699 141.624C121.956 144.922 121.085 148.74 121.085 153.079Z" />
            {/* i w/o dot */}
            <path d="M209.824 115.2L220.671 117.282L231.648 115.2V190.047H209.824V115.2Z" />
          </g>

          {/* dot */}
          <path
            style={{animationFillMode: 'both'}}
            d="M220.67 107.519C216.75 107.519 213.526 106.521 211 104.526C208.561 102.443 207.341 99.7092 207.341 96.3248C207.341 92.8536 208.561 90.12 211 88.1241C213.526 86.0414 216.75 85 220.67 85C224.678 85 227.901 86.0414 230.341 88.1241C232.78 90.12 234 92.8536 234 96.3248C234 99.7092 232.78 102.443 230.341 104.526C227.901 106.521 224.678 107.519 220.67 107.519Z"
            className={clsx(
              'origin-[219px_95px] fill-[#fff]',
              variant === 'loading' && 'animate-bounce'
            )}
          />
        </mask>
      </defs>

      {/* Qii */}
      <path
        style={{transformBox: 'fill-box', animationFillMode: 'both'}}
        d="M43.38 66.93H42.2334L43.0136 67.7702L61.4474 87.622C60.3076 87.694 59.1385 87.73 57.94 87.73C50.9794 87.73 44.9467 86.4841 39.8276 84.0098C34.7102 81.5364 30.7554 78.0043 27.9483 73.412C25.2289 68.8216 23.86 63.4104 23.86 57.16C23.86 50.9095 25.229 45.4982 27.9485 40.9078C30.7556 36.3156 34.7103 32.7835 39.8276 30.3102C44.9467 27.8359 50.9794 26.59 57.94 26.59C64.9887 26.59 71.0196 27.8364 76.0495 30.3087L76.0524 30.3102C81.1697 32.7835 85.0798 36.3148 87.7998 40.9049L87.8033 40.9107C90.6084 45.5008 92.02 50.911 92.02 57.16C92.02 63.409 90.6084 68.8192 87.8033 73.4093L87.7998 73.4151C86.3333 75.8899 84.5209 78.0568 82.3599 79.9161L70.2638 67.087L70.1158 66.93H69.9H43.38ZM57.94 108.36C65.2917 108.36 72.0574 107.474 78.233 105.699L85.2636 113.27L85.412 113.43H85.63H112.8H113.959L113.164 112.587L97.4695 95.9416C101.714 92.5814 105.276 88.6267 108.153 84.0772L108.154 84.075C112.976 76.3591 115.38 67.3814 115.38 57.16C115.38 46.9389 112.977 38.0036 108.153 30.3732C103.334 22.664 96.5892 16.6671 87.9329 12.3824C79.358 8.09512 69.3556 5.95999 57.94 5.95999C46.5239 5.95999 36.4788 8.09529 27.8182 12.3819L27.8164 12.3828C19.2459 16.668 12.5448 22.6653 7.72664 30.3739C2.90324 38.0041 0.5 46.9392 0.5 57.16C0.5 67.3814 2.90351 76.3591 7.72596 84.075L7.72733 84.0772C12.5459 91.6992 19.247 97.6525 27.8164 101.937L27.8182 101.938C36.4788 106.225 46.5239 108.36 57.94 108.36ZM130.245 30.669L129.65 30.5544V31.16V105.91V106.41H130.15H151.86H152.36V105.91V31.16V30.5558L151.767 30.6688L140.941 32.7309L130.245 30.669ZM130.995 20.8796L131.002 20.8858L131.009 20.8917C133.629 22.9693 136.952 23.99 140.94 23.99C145.011 23.99 148.34 22.9711 150.877 20.8864L150.886 20.8796C153.43 18.6986 154.7 15.8264 154.7 12.31C154.7 8.71324 153.434 5.83564 150.882 3.73697C148.344 1.5638 145.014 0.5 140.94 0.5C136.947 0.5 133.621 1.56676 131.001 3.7348C128.447 5.83366 127.18 8.712 127.18 12.31C127.18 15.8264 128.45 18.6986 130.995 20.8796ZM170.331 30.669L169.736 30.5544V31.16V105.91V106.41H170.236H191.946H192.446V105.91V31.16V30.5558L191.853 30.6688L181.027 32.7309L170.331 30.669ZM171.081 20.8796L171.088 20.8858L171.095 20.8917C173.715 22.9693 177.038 23.99 181.026 23.99C185.097 23.99 188.425 22.9711 190.963 20.8864L190.971 20.8796C193.516 18.6986 194.786 15.8264 194.786 12.31C194.786 8.71324 193.52 5.83564 190.967 3.73697C188.43 1.5638 185.099 0.5 181.026 0.5C177.033 0.5 173.707 1.56676 171.087 3.7348C168.533 5.83366 167.266 8.712 167.266 12.31C167.266 15.8264 168.536 18.6986 171.081 20.8796Z"
        className={clsx('fill-slate12')}
      />

      <g mask="url(#logo-mask)">
        <rect x="98" y="25" width="137" height="180" fill="url(#lg)" />
      </g>
    </svg>
  );
}

Logo.displayName = 'Logo';
